export enum PrimeMode {
  VIDEO = 1,
  PRACTICE = 2,
  TEST = 3,
  COMPETE = 5
}

export enum UserPlatformPlan {
  FREE = 0,
  PAID = 1
}

export enum QuotaType {
  PRIME_VIDEO_WATCHED = 1,
  PRIME_PRACTICE = 2,
  PRIME_TEST = 3,
  PRIME_COMPETE = 4
}

export interface Usage {
  total: number;
  freqType: number;
  unit: string;
  used: number;
}

export interface QuotaItem {
  header: string;
  usages: Usage[];
  quotaType: QuotaType;
}

export interface QuotaDetails {
  primeTestDetails?: QuotaItem;
  primeVideoWatchedDetails?: QuotaItem;
  primePracticeDetails?: QuotaItem;
  primeCompeteDetails?: QuotaItem;
}

export interface QuotaDetailsResponse {
  quotaDetails: QuotaDetails;
  userPlatformPlan: UserPlatformPlan;
}

export type UnlockedEntityResponse = string[];

export interface ConsumeQuotaResponse {
  success: boolean;
  quotaDetails?: QuotaDetails;
  userPlatformPlan?: UserPlatformPlan;
}

export interface PrimeQuotaResult {
  quotaType: QuotaType;
  freqType?: number;
  total: number;
  used: number;
  left: number;
  isQuotaExhausted: boolean;
  userPlatformPlan: UserPlatformPlan | null;
}

export interface FetchQuotaParams {
  goalUID: string;
  accessToken?: string;
}

export interface ConsumeQuotaParams {
  goalUID: string;
  objectUID?: string;
  mode: PrimeMode;
  accessToken?: string;
}
